import { ArrowRight } from "@/components/icons";
import { HoverPrefetchLink } from "@/components/ui/hover-prefetch-link";

export function LandingSectionHead({
  id,
  heading,
  shortHeading,
  description,
  action,
}: {
  id: string;
  heading: string;
  shortHeading?: string;
  description?: string;
  action?: { href: string; label: string; shortLabel: string };
}) {
  return (
    <div className="flex items-center justify-between gap-x-6 gap-y-2 sm:flex-wrap sm:items-end">
      <div className="flex min-w-0 flex-col gap-1.5">
        <h2
          id={id}
          className="text-[17px] font-semibold leading-[1.3] tracking-[-0.01em] text-foreground sm:text-[28px] sm:leading-[1.2] sm:tracking-[-0.015em]"
        >
          {shortHeading ? (
            <>
              <span className="sm:hidden">{shortHeading}</span>
              <span className="max-sm:hidden">{heading}</span>
            </>
          ) : (
            heading
          )}
        </h2>
        {description ? (
          <p className="text-[15px] leading-[1.6] text-fg-muted max-sm:hidden">{description}</p>
        ) : null}
      </div>
      {action ? (
        <HoverPrefetchLink
          href={action.href}
          className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-brand-strong hover:underline sm:text-[15px] sm:font-semibold"
        >
          <span className="sm:hidden">{action.shortLabel}</span>
          <span className="max-sm:hidden">{action.label}</span>
          <ArrowRight aria-hidden className="size-4 max-sm:hidden" />
        </HoverPrefetchLink>
      ) : null}
    </div>
  );
}
